// ButtonLink.tsx
"use client";

import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@perk/core/lib/utils";
import { CustomLink, type UniversalHref } from "./custom-link";
import { buttonVariants } from "./ui/button";

export interface ButtonLinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href">,
    VariantProps<typeof buttonVariants> {
  href: UniversalHref;
  asChild?: boolean;
}

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  (
    { className, variant, size, asChild = false, href, children, ...props },
    ref
  ) => {
    const Component = asChild ? Slot : CustomLink;

    return (
      <Component
        ref={ref}
        href={href}
        className={cn(buttonVariants({ variant, size, className }))}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

ButtonLink.displayName = "ButtonLink";
